import BaseModel from '@/app-core/lib/data/model/BaseModel'
import OtpValidator from '@/app-core/api/validations/otp/OtpValidator'
import OtpResource from '@/app-core/api/resources/otp/OtpResource'
import API from '@/app-core/api/Api'
import dayjs from 'dayjs'
import {EventBus} from '@/app-core/lib/events/eventBus'

export default class OtpModel extends BaseModel {
  // eslint-disable-next-line no-unused-private-class-members
  #timeInterval = null

  constructor(payload = {}, resource = OtpResource, validator = OtpValidator) {
    super(payload, resource, validator)
  }

  boot() {
    super.boot()

    this.guarded = ['time', 'email', 'phone', 'prefix', 'timeInterval']
  }

  /* PROPERTIES */

  /* METHODS */

  TimerStart() {
    let duration = null
    const seconds = parseInt(this.time)
    const endDate = dayjs().add(seconds, 'second')
    const retVal = {
      day   : 0,
      hour  : 0,
      minute: 0,
      second: 0
    }

    this.TimerStop(false)
    EventBus.$emit('otp:time-start')

    this.timeInterval = setInterval(() => {
      duration = dayjs.duration(endDate.diff(dayjs()))

      retVal.day = `${duration.$d.days}`

      retVal.hour = duration.$d.hours >= 0 && duration.$d.hours > 9 ? `${duration.$d.hours}` : `0${duration.$d.hours}`

      retVal.minute = duration.$d.minutes >= 0 && duration.$d.minutes > 9 ? `${duration.$d.minutes}` : `0${duration.$d.minutes}`

      retVal.second = duration.$d.seconds >= 0 && duration.$d.seconds > 9 ? `${duration.$d.seconds}` : `0${duration.$d.seconds}`

      EventBus.$emit('otp:time-progress', retVal)

      if (parseInt(retVal.day) <= 0 && parseInt(retVal.hour) <= 0 && parseInt(retVal.minute) <= 0 && parseInt(retVal.second) <= 0) {
        this.TimerStop(true)
      }
    }, 1000)
  }

  TimerStop(emitEvent = true) {
    if (this.timeInterval) {
      clearInterval(this.timeInterval)
      if (emitEvent) EventBus.$emit('otp:time-end')
    }
  }

  async Get() {
    let payload

    if (this.type === 'email') {
      payload = {
        email: this.email,
        type : this.type
      }
    } else {
      payload = {
        phone : this.phone,
        prefix: this.prefix,
        type  : this.type
      }
    }
    return await API.Resource.Otp.Get(payload)
  }

  async Verify() {
    return await API.Resource.Otp.Validate(this.clone())
  }
}
